// Mock data for "Best For Medals HK Limited"
// NOTE: All data here is MOCKED for the frontend teaser. Will be replaced by backend API later.

export const company = {
  name: "Best For Medals",
  legal: "Best For Medals HK Limited",
  tagline: "Custom Medals, Sportswear & Event Merchandise Manufacturer",
  positioning:
    "Factory Direct Production in China | Offices in Hong Kong, United Kingdom & Spain | Worldwide Shipping",
  email: "sales@bestformedals.com",
  phone: "+852 3050 1288",
  whatsapp: "+852 6000 1288",
  addressCN:
    "Zhao Lin Industrial 2nd Rd, Xie Gang, Dongguan, Guangdong, China 523595",
  offices: [
    { city: "Hong Kong", role: "Headquarters", flag: "HK" },
    { city: "United Kingdom", role: "European Sales Office", flag: "UK" },
    { city: "Spain", role: "Southern Europe Office", flag: "ES" },
    { city: "Atlanta, USA", role: "Coming Soon", flag: "US" },
  ],
};

export const heroSlides = [
  {
    id: 1,
    title: "Custom Medals, Sportswear & Event Merchandise",
    highlight: "Direct From Factory",
    subtitle:
      "Manufacturing high-quality products for sporting events, sports clubs and promotional campaigns worldwide.",
    image:
      "https://images.unsplash.com/photo-1706374503312-7a4a4c030d2d",
  },
  {
    id: 2,
    title: "Marathon & Finisher Medals",
    highlight: "That Runners Remember",
    subtitle:
      "Metal, wooden, acrylic and hybrid medals — designed and produced in our own facilities.",
    image: "https://images.unsplash.com/photo-1508730328641-47c1616341b7",
  },
  {
    id: 3,
    title: "Teamwear & Custom Sportswear",
    highlight: "For Clubs Worldwide",
    subtitle:
      "Football, basketball, rugby and tennis kits with OEM / ODM private label manufacturing.",
    image: "https://images.unsplash.com/photo-1552066379-e7bfd22155c5",
  },
];

export const whyChooseUs = [
  {
    icon: "Factory",
    title: "Direct Manufacturer",
    text: "Own production facilities in China — not a trading company.",
  },
  {
    icon: "Globe2",
    title: "International Presence",
    text: "Offices in Hong Kong, United Kingdom and Spain.",
  },
  {
    icon: "BadgeDollarSign",
    title: "Factory Direct Pricing",
    text: "No middlemen — competitive factory-direct pricing.",
  },
  {
    icon: "Zap",
    title: "Fast Sampling",
    text: "Rapid artwork and sample development for every project.",
  },
  {
    icon: "Ship",
    title: "Worldwide Shipping",
    text: "Serving customers across Europe, North America & Australia.",
  },
  {
    icon: "ShieldCheck",
    title: "Professional Quality Control",
    text: "Strict production standards and multi-stage inspections.",
  },
];

export const categories = [
  {
    slug: "medals-awards",
    name: "Medals & Awards",
    short: "Custom Medals",
    tagline: "Metal, wooden, acrylic & hybrid medals",
    description:
      "From marathon finisher medals to championship trophies — designed, moulded and finished in our own factory. No MOQ, fast sampling and premium plating options.",
    image: "https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg",
    subcategories: [
      "Metal Medals",
      "Wooden Medals",
      "Acrylic Medals",
      "Hybrid Medals",
      "Trophies & Awards",
      "Medal Accessories",
    ],
  },
  {
    slug: "running-marathon",
    name: "Running & Marathon",
    short: "Running Merchandise",
    tagline: "Everything race organizers need",
    description:
      "A specialist supplier for race organizers — technical running apparel, event branding, runner bags and finisher merchandise, all factory direct.",
    image: "https://images.pexels.com/photos/18275606/pexels-photo-18275606.jpeg",
    subcategories: [
      "Running Apparel",
      "Runner Bags",
      "Event Branding",
      "Event Merchandise",
    ],
  },
  {
    slug: "teamwear",
    name: "Teamwear & Sports Uniforms",
    short: "Teamwear",
    tagline: "Kits for clubs & academies",
    description:
      "Custom sublimated football, basketball, rugby and tennis kits with full OEM / ODM and private label manufacturing for clubs and academies.",
    image: "https://images.unsplash.com/photo-1552066379-e7bfd22155c5",
    subcategories: ["Football", "Basketball", "Rugby", "Tennis", "Club Collection"],
  },
  {
    slug: "promotional-products",
    name: "Promotional Products",
    short: "Promotional",
    tagline: "Pins, coins, keychains & more",
    description:
      "Enamel pins, challenge coins, keychains, lanyards and wristbands — the perfect promotional and event merchandise, produced in-house.",
    image: "https://images.unsplash.com/photo-1574097638739-725b61f511a5",
    subcategories: ["Pins", "Keychains", "Challenge Coins", "Lanyards", "Wristbands"],
  },
];

export const industries = [
  "Marathons",
  "Running Events",
  "Trail Races",
  "Cycling Events",
  "Triathlons",
  "Football Clubs",
  "Basketball Clubs",
  "Rugby Clubs",
  "Tennis Clubs",
  "Schools & Universities",
  "Sports Federations",
  "Corporate Sports Events",
];

// ---------- PRODUCTS ----------
const medalImgs = [
  "https://images.unsplash.com/photo-1771402899312-d8d20eea333e",
  "https://images.pexels.com/photos/21690899/pexels-photo-21690899.jpeg",
  "https://images.unsplash.com/photo-1774557937677-7041873b227a",
  "https://images.unsplash.com/photo-1508730328641-47c1616341b7",
  "https://images.unsplash.com/photo-1558514974-2bcf0b1d2877",
  "https://images.pexels.com/photos/6345360/pexels-photo-6345360.jpeg",
  "https://images.unsplash.com/photo-1706374503312-7a4a4c030d2d",
  "https://images.pexels.com/photos/6250937/pexels-photo-6250937.jpeg",
  "https://images.pexels.com/photos/34384082/pexels-photo-34384082.jpeg",
  "https://images.unsplash.com/photo-1613826488066-5a115a53a1fc",
  "https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg",
  "https://images.unsplash.com/photo-1514820720301-4c4790309f46",
  "https://images.unsplash.com/photo-1697209868660-c5991488f7b1",
  "https://images.unsplash.com/photo-1578269174936-2709b6aeb913",
  "https://images.unsplash.com/photo-1642104744809-14b986179927",
];
const runImgs = [
  "https://images.pexels.com/photos/18275606/pexels-photo-18275606.jpeg",
  "https://images.pexels.com/photos/10313668/pexels-photo-10313668.jpeg",
  "https://images.unsplash.com/photo-1552674605-db6ffd4facb5",
  "https://images.unsplash.com/photo-1596727362302-b8d891c42ab8",
  "https://images.unsplash.com/photo-1452626038306-9aae5e071dd3",
  "https://images.pexels.com/photos/18408979/pexels-photo-18408979.jpeg",
  "https://images.pexels.com/photos/33951658/pexels-photo-33951658.jpeg",
  "https://images.unsplash.com/photo-1632650312771-52c324fb4d83",
  "https://images.unsplash.com/photo-1769867626569-e61d02806e69",
  "https://images.pexels.com/photos/12443510/pexels-photo-12443510.jpeg",
  "https://images.pexels.com/photos/17924329/pexels-photo-17924329.jpeg",
  "https://images.pexels.com/photos/28726897/pexels-photo-28726897.jpeg",
];
const teamImgs = [
  "https://images.unsplash.com/photo-1552066379-e7bfd22155c5",
  "https://images.unsplash.com/photo-1551854321-1432edd90a5c",
  "https://images.unsplash.com/photo-1551854386-b42759a60dd0",
  "https://images.unsplash.com/photo-1781931298345-4a736a26109c",
  "https://images.unsplash.com/photo-1551330299-3db95c0ca3d4",
  "https://images.pexels.com/photos/20615486/pexels-photo-20615486.jpeg",
  "https://images.pexels.com/photos/20615456/pexels-photo-20615456.jpeg",
  "https://images.unsplash.com/photo-1551330299-5b92e951b570",
  "https://images.pexels.com/photos/35162974/pexels-photo-35162974.jpeg",
  "https://images.unsplash.com/photo-1736752306580-6a4b32c3c281",
  "https://images.unsplash.com/photo-1534371517819-3cb56b0e4c6f",
  "https://images.unsplash.com/photo-1780336672587-a452525c3631",
];
const promoImgs = [
  "https://images.unsplash.com/photo-1574097638739-725b61f511a5",
  "https://images.pexels.com/photos/14420435/pexels-photo-14420435.jpeg",
  "https://images.unsplash.com/photo-1574097639425-d1dce599e9f3",
  "https://images.pexels.com/photos/16151365/pexels-photo-16151365.jpeg",
  "https://images.pexels.com/photos/16043293/pexels-photo-16043293.jpeg",
  "https://images.unsplash.com/photo-1769142726489-6f40b1c575c5",
  "https://images.unsplash.com/photo-1668520192949-a86b1ebf8797",
  "https://images.unsplash.com/photo-1565667304823-5371966bd6c7",
];
const coinImgs = [
  "https://images.pexels.com/photos/34384082/pexels-photo-34384082.jpeg",
  "https://images.pexels.com/photos/16043293/pexels-photo-16043293.jpeg",
  "https://images.unsplash.com/photo-1613826488066-5a115a53a1fc",
  "https://images.pexels.com/photos/16151365/pexels-photo-16151365.jpeg",
];

let _pid = 0;
const p = (name, category, subcategory, image, material, tags) => ({
  id: `p${++_pid}`,
  name,
  category,
  subcategory,
  image,
  material,
  moq: "No MOQ",
  leadTime: "10-15 days",
  tags: tags || [],
  description: `Custom ${name.toLowerCase()} manufactured factory-direct with your artwork, logo and colours. Fast sampling, premium finishing and worldwide shipping.`,
  features: [
    "Fully custom design & artwork",
    "Factory-direct pricing",
    "Free digital proof & sampling",
    "Worldwide express shipping",
  ],
});

const medalNames = [
  ["Classic Metal Marathon Medal", "Metal Medals", 0],
  ["Die Cast 3D Finisher Medal", "Metal Medals", 3],
  ["Stamped Iron Race Medal", "Metal Medals", 1],
  ["Ultra Marathon Finisher Medal", "Metal Medals", 4],
  ["Soft Enamel Sports Medal", "Metal Medals", 5],
  ["Hard Enamel Award Medal", "Metal Medals", 7],
  ["Glitter Fill Event Medal", "Metal Medals", 2],
  ["Glow-in-the-Dark Medal", "Metal Medals", 6],
  ["Translucent Epoxy Medal", "Acrylic Medals", 8],
  ["Spinner Rotating Medal", "Metal Medals", 9],
  ["Two-Plating Antique Medal", "Metal Medals", 10],
  ["Eco-Friendly Wooden Medal", "Wooden Medals", 3],
  ["Bamboo Trail Running Medal", "Wooden Medals", 2],
  ["Acrylic UV-Printed Medal", "Acrylic Medals", 8],
  ["Transparent Acrylic Medal", "Acrylic Medals", 9],
  ["Hybrid Metal + Wood Medal", "Hybrid Medals", 4],
  ["Hybrid Metal + Acrylic Medal", "Hybrid Medals", 0],
  ["Metal Trophy Award", "Trophies & Awards", 11],
  ["Crystal Glass Award", "Trophies & Awards", 14],
  ["Championship Ring", "Trophies & Awards", 13],
];
const runNames = [
  ["Technical Running T-Shirt", "Running Apparel", 8],
  ["Performance Dry-Fit Shirt", "Running Apparel", 2],
  ["Sublimated Running Singlet", "Running Apparel", 3],
  ["Compression Running Socks", "Running Apparel", 9],
  ["Multifunctional Buff / Neck Gaiter", "Running Apparel", 4],
  ["Performance Running Cap", "Running Apparel", 1],
  ["Trucker Mesh Cap", "Running Apparel", 0],
  ["Event Drawstring Bag", "Runner Bags", 10],
  ["Finisher Gift Bag", "Runner Bags", 11],
  ["Custom Event Backpack", "Runner Bags", 10],
  ["Printed Race Bib", "Event Merchandise", 9],
  ["Tyvek Marathon Bib", "Event Merchandise", 5],
  ["Event Feather Flag", "Event Branding", 6],
  ["Finish Line Banner", "Event Branding", 5],
  ["Sponsor Backdrop Wall", "Event Branding", 7],
  ["Event Lanyard", "Event Merchandise", 0],
  ["Silicone Event Wristband", "Event Merchandise", 3],
  ["Fabric Festival Wristband", "Event Merchandise", 1],
  ["Reflective Running Vest", "Running Apparel", 2],
  ["Runner Arm Sleeve", "Running Apparel", 4],
];
const teamNames = [
  ["Custom Football Match Jersey", "Football", 0],
  ["Football Goalkeeper Kit", "Football", 1],
  ["Football Training Kit", "Football", 2],
  ["Football Shorts & Socks Set", "Football", 3],
  ["Warm-Up Track Jacket", "Club Collection", 9],
  ["Basketball Reversible Jersey", "Basketball", 4],
  ["Basketball Team Shorts", "Basketball", 5],
  ["Basketball Full Team Set", "Basketball", 6],
  ["Rugby Match Shirt", "Rugby", 7],
  ["Rugby Training Wear", "Rugby", 10],
  ["Rugby Team Shorts", "Rugby", 11],
  ["Tennis Performance Polo", "Tennis", 8],
  ["Tennis Skirt", "Tennis", 9],
  ["Tennis Training Set", "Tennis", 10],
  ["Club Tracksuit", "Club Collection", 11],
  ["Team Hoodie", "Club Collection", 9],
  ["Club Polo Shirt", "Club Collection", 8],
  ["Padded Bench Jacket", "Club Collection", 10],
  ["Travel / Presentation Wear", "Club Collection", 11],
  ["Custom Sublimated Kit (OEM)", "Football", 3],
];
const promoNames = [
  ["Soft Enamel Lapel Pin", "Pins", promoImgs[0]],
  ["Hard Enamel Pin", "Pins", promoImgs[1]],
  ["Corporate Logo Pin", "Pins", promoImgs[2]],
  ["Event Trading Pin", "Pins", promoImgs[0]],
  ["Die-Struck Metal Pin", "Pins", promoImgs[1]],
  ["Metal Keychain", "Keychains", promoImgs[3]],
  ["Enamel Keychain", "Keychains", promoImgs[4]],
  ["PVC Rubber Keychain", "Keychains", promoImgs[3]],
  ["Bottle Opener Keychain", "Keychains", promoImgs[4]],
  ["Military Challenge Coin", "Challenge Coins", coinImgs[0]],
  ["Commemorative Coin", "Challenge Coins", coinImgs[2]],
  ["Corporate Challenge Coin", "Challenge Coins", coinImgs[1]],
  ["Antique Gold Coin", "Challenge Coins", coinImgs[3]],
  ["Sublimated Lanyard", "Lanyards", promoImgs[5]],
  ["Woven Lanyard", "Lanyards", promoImgs[6]],
  ["Event ID Lanyard", "Lanyards", promoImgs[5]],
  ["Silicone Wristband", "Wristbands", promoImgs[7]],
  ["Fabric Event Wristband", "Wristbands", promoImgs[7]],
  ["Embroidered Patch", "Pins", promoImgs[2]],
  ["Custom Dog Tag", "Keychains", promoImgs[4]],
];

export const products = [
  ...medalNames.map(([n, s, i]) =>
    p(n, "medals-awards", s, medalImgs[i], "Zinc alloy / iron / wood / acrylic", ["Best Seller"].slice(0, i % 3 === 0 ? 1 : 0))
  ),
  ...runNames.map(([n, s, i]) =>
    p(n, "running-marathon", s, runImgs[i], "Technical polyester / textile", i % 4 === 0 ? ["Popular"] : [])
  ),
  ...teamNames.map(([n, s, i]) =>
    p(n, "teamwear", s, teamImgs[i], "Breathable sublimation fabric", i % 5 === 0 ? ["OEM"] : [])
  ),
  ...promoNames.map(([n, s, img]) =>
    p(n, "promotional-products", s, img, "Metal / enamel / silicone / fabric", [])
  ),
];

export const featuredProjects = [
  {
    title: "City Marathon Finisher Medals",
    category: "Medals & Awards",
    image: "https://images.unsplash.com/photo-1508730328641-47c1616341b7",
    desc: "12,000 custom die-cast finisher medals delivered for an international city marathon.",
  },
  {
    title: "Trail Series Wooden Medals",
    category: "Medals & Awards",
    image: "https://images.unsplash.com/photo-1774557937677-7041873b227a",
    desc: "Sustainable bamboo medals for a European trail running series.",
  },
  {
    title: "Football Club Full Kit Program",
    category: "Teamwear",
    image: "https://images.unsplash.com/photo-1551854386-b42759a60dd0",
    desc: "Complete sublimated home & away kits for a semi-professional football club.",
  },
  {
    title: "Race Event Branding Package",
    category: "Running & Marathon",
    image: "https://images.pexels.com/photos/18408979/pexels-photo-18408979.jpeg",
    desc: "Flags, banners, backdrops and lanyards for a half-marathon event.",
  },
  {
    title: "Corporate Challenge Coins",
    category: "Promotional",
    image: "https://images.pexels.com/photos/34384082/pexels-photo-34384082.jpeg",
    desc: "Two-plating commemorative coins for a global corporate anniversary.",
  },
  {
    title: "Basketball Academy Team Sets",
    category: "Teamwear",
    image: "https://images.unsplash.com/photo-1551330299-3db95c0ca3d4",
    desc: "Reversible jerseys and shorts for a youth basketball academy.",
  },
];

export const testimonials = [
  {
    name: "Sarah Thompson",
    role: "Race Director, UK",
    text: "Best For Medals delivered stunning finisher medals two weeks ahead of schedule. Communication in English was flawless.",
    rating: 5,
  },
  {
    name: "Marco Rossi",
    role: "Football Club Manager, Spain",
    text: "Factory-direct pricing on our team kits saved us thousands, and the sublimation quality is superb.",
    rating: 5,
  },
  {
    name: "Emily Carter",
    role: "Promotional Buyer, USA",
    text: "Their sampling speed is unreal. We had proofs within 48 hours and reorders are effortless.",
    rating: 5,
  },
  {
    name: "David Nguyen",
    role: "Event Organizer, Australia",
    text: "A real manufacturer with European-level service. Our event branding package looked world-class.",
    rating: 5,
  },
];

export const factory = {
  stats: [
    { value: "5,000+", label: "m² Factory Area" },
    { value: "150+", label: "Skilled Workers" },
    { value: "12+", label: "Years Experience" },
    { value: "60+", label: "Countries Served" },
  ],
  process: [
    { step: "01", title: "Design & Artwork", desc: "Free digital proofs from your sketch, logo or idea." },
    { step: "02", title: "Mould Development", desc: "Precision moulds carved for metal and die-cast products." },
    { step: "03", title: "Production", desc: "Casting, stamping, plating, sublimation and assembly." },
    { step: "04", title: "Quality Inspection", desc: "Material, in-process and final multi-stage inspection." },
    { step: "05", title: "Packaging", desc: "Presentation boxes, ribbons and retail-ready packing." },
    { step: "06", title: "Worldwide Shipping", desc: "Express, air and sea freight via DHL, UPS, FedEx & more." },
  ],
  gallery: [
    "https://images.pexels.com/photos/37598393/pexels-photo-37598393.png",
    "https://images.pexels.com/photos/10031804/pexels-photo-10031804.jpeg",
    "https://images.unsplash.com/photo-1598302936625-6075fbd98dd7",
    "https://images.unsplash.com/photo-1740209475472-aa7d280f7452",
    "https://images.pexels.com/photos/8956445/pexels-photo-8956445.jpeg",
    "https://images.pexels.com/photos/35290693/pexels-photo-35290693.jpeg",
  ],
  certifications: ["ISO 9001", "BSCI", "Disney FAMA", "SEDEX", "REACH", "RoHS"],
};

export const galleryItems = [
  { image: medalImgs[3], category: "Medals", title: "Marathon Finisher Medal" },
  { image: medalImgs[6], category: "Medals", title: "Gold Award Medals" },
  { image: runImgs[0], category: "Running Events", title: "City Marathon" },
  { image: runImgs[5], category: "Event Branding", title: "Finish Line Setup" },
  { image: teamImgs[2], category: "Teamwear", title: "Football Kit" },
  { image: teamImgs[4], category: "Teamwear", title: "Basketball Set" },
  { image: promoImgs[0], category: "Promotional Products", title: "Enamel Pins" },
  { image: promoImgs[5], category: "Promotional Products", title: "Custom Lanyards" },
  { image: medalImgs[11], category: "Medals", title: "Trophy Awards" },
  { image: runImgs[2], category: "Running Events", title: "Race Day" },
  { image: teamImgs[8], category: "Teamwear", title: "Club Collection" },
  { image: promoImgs[3], category: "Promotional Products", title: "Metal Keychains" },
  { image: medalImgs[8], category: "Medals", title: "Translucent Medal" },
  { image: runImgs[10], category: "Finished Projects", title: "Event Bags" },
  { image: teamImgs[6], category: "Teamwear", title: "Team Shorts" },
  { image: promoImgs[7], category: "Promotional Products", title: "Silicone Wristbands" },
];

export const blogPosts = [
  {
    slug: "how-to-design-a-marathon-medal",
    title: "How to Design a Marathon Medal That Runners Will Treasure",
    category: "Medals",
    date: "June 12, 2025",
    author: "Best For Medals Team",
    image: medalImgs[3],
    excerpt:
      "From concept to finish line — the essential steps to create a memorable marathon finisher medal that reflects your event's identity.",
  },
  {
    slug: "running-event-merchandise-guide",
    title: "The Complete Running Event Merchandise Guide",
    category: "Running",
    date: "May 28, 2025",
    author: "Best For Medals Team",
    image: runImgs[0],
    excerpt:
      "Everything race organizers need to know about sourcing apparel, bags, bibs and event branding directly from a factory.",
  },
  {
    slug: "choosing-the-right-race-bib",
    title: "Choosing the Right Race Bib for Your Event",
    category: "Running",
    date: "May 10, 2025",
    author: "Best For Medals Team",
    image: runImgs[8],
    excerpt:
      "Tyvek, paper or synthetic? A practical breakdown of race bib materials, printing and timing chip options.",
  },
  {
    slug: "football-teamwear-buying-guide",
    title: "Football Teamwear Buying Guide for Clubs",
    category: "Teamwear",
    date: "April 22, 2025",
    author: "Best For Medals Team",
    image: teamImgs[2],
    excerpt:
      "How to specify fabrics, sublimation and sizing to get professional-grade kits at factory-direct prices.",
  },
  {
    slug: "custom-sportswear-manufacturing",
    title: "Custom Sportswear Manufacturing: OEM vs ODM",
    category: "Teamwear",
    date: "April 5, 2025",
    author: "Best For Medals Team",
    image: teamImgs[4],
    excerpt:
      "Understand the difference between OEM, ODM and private label manufacturing and which is right for your brand.",
  },
  {
    slug: "medal-trends-for-running-events",
    title: "Medal Trends for Running Events in 2025",
    category: "Medals",
    date: "March 18, 2025",
    author: "Best For Medals Team",
    image: medalImgs[8],
    excerpt:
      "Spinner medals, glow-in-the-dark finishes and sustainable materials — the trends shaping event medals this year.",
  },
];

export const productCategoryOptions = [
  "Custom Medals",
  "Running & Marathon Merchandise",
  "Teamwear & Sports Uniforms",
  "Promotional Products",
  "Trophies & Awards",
  "Other",
];
